import React from 'react'
import { Outlet } from 'react-router-dom'

import SellerHeader from "../Components/seller/SellerHeader"
import BuyerFooter from "../Components/buyer/BuyerFooter"
import FloatingChatWidget from "../Components/buyer/FloatingChatWidget"

function Layout( {isFooter = true} ) {

    if(!isFooter){
        return (
            <div>
                <SellerHeader />
                <Outlet />
                <FloatingChatWidget />
            </div>
        )
    }

    return (
        <div>
            <SellerHeader />
            <Outlet />
            <BuyerFooter />
            <FloatingChatWidget />
        </div>
    )
}

export default Layout